import React from 'react';
import {ViewProps} from 'react-native';
import {Platform, StyleSheet, View, ViewStyle} from 'react-native';

type ContentViewProps = ViewProps & {
  parentStyle?: ViewStyle;
};
const ContentView = ({
  style,
  parentStyle,
  children,
  ...rest
}: ContentViewProps) => (
  <View
    testID="content-view-parent"
    {...rest}
    style={[styles.parent, parentStyle]}>
    <View testID="content-view-content" style={[styles.content, style]}>
      {children}
    </View>
  </View>
);

export default ContentView;

const styles = StyleSheet.create({
  parent: {
    ...Platform.select({
      native: {
        flex: 1,
        paddingVertical: 10,
      },
      web: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        paddingVertical: 10,
      },
    }),
  },
  content: {
    ...Platform.select({
      native: {
        flex: 1,
        paddingHorizontal: 16,
      },
      web: {
        flex: 1,
        maxWidth: '1320px',
        paddingHorizontal: 16,
      },
    }),
  },
});
